import React from 'react';
import classNames from 'classnames';

import IconRenderer, { IconProps } from 'ui/icons/IconRenderer';

import icon from './stars.svg';

import styles from './index.module.scss';

const IconStars = ({ className, style }: IconProps) => (
  <IconRenderer
    iconHtml={icon}
    className={classNames(styles.icon, className)}
    style={style}
  />
);

export default IconStars;
